import { render, staticRenderFns } from "./TablesPage.vue?vue&type=template&id=4adf9a64&scoped=true&"
import script from "./TablesPage.vue?vue&type=script&lang=js&"
export * from "./TablesPage.vue?vue&type=script&lang=js&"
import style0 from "./TablesPage.vue?vue&type=style&index=0&id=4adf9a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf9a64",
  null
  
)

export default component.exports